import { useQuery } from "@tanstack/react-query";
import { plansApi, type AddOn } from "@/api/plans-api";

export function useAddOns() {
  const { data, isLoading, error } = useQuery<AddOn[]>({
    queryKey: ["billingAddOns"],
    queryFn: () => plansApi.listAddOns(),
    staleTime: 10 * 60 * 1000,
  });

  return {
    addOns: data ?? [],
    isLoading,
    error,
  };
}
